import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.js";
import { Lazyload } from "@fancyapps/ui/dist/carousel/carousel.lazyload.js";
import { Thumbs } from "@fancyapps/ui/dist/carousel/carousel.thumbs.js";
import { Dots } from "@fancyapps/ui/dist/carousel/carousel.dots.js";
import { Arrows } from "@fancyapps/ui/dist/carousel/carousel.arrows.js";
import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.js";
import { vimeoAllowed, onVimeoAllowed } from './modules/utils/vimeo-consent';

const mainBanner = document.querySelector('.main-banner');
if (mainBanner) {

        let rotationTime = getRotationTime(mainBanner);

        const loadActiveSlideVideos = () => {
            // Fancyapps emituje 'change' ZANIM przeniesie .is-selected ze starego
            // slajdu na nowy. rAF odracza query o jedną klatkę, dzięki czemu
            // łapiemy DOM po tym jak biblioteka skończy synchroniczny class swap.
            requestAnimationFrame(() => {
                const activeSlide = mainBanner.querySelector('.f-carousel__slide.is-selected');
                loadCarouselVideos(activeSlide);
            });
        };

        const mainCarousel = Carousel(mainBanner, {
            slidesPerPage: 1,
            transition: 'tween', // tween/fade
            tween: {
                friction: 20,
            },
            infinite: true,
            Autoplay: (rotationTime && rotationTime > 0) ? { showProgressbar: false, timeout: rotationTime, } : false,
            Dots: {
                dotTpl: "<span data-carousel-go-to=\"%i\"></span>",
            },
            Lazyload: {
                preload: 0,
                showLoading: false,
            },
            on: {
                ready: loadActiveSlideVideos,
                change: loadActiveSlideVideos,
                attachSlideEl: loadActiveSlideVideos,
            }
        }, {
            Lazyload,
            Dots,
            Autoplay
        }).init();

        window.addEventListener('resize', () => {
            if (!mainBanner.querySelector('iframe[data-carousel-video]')) return;
            loadActiveSlideVideos();
        });

        onVimeoAllowed(loadActiveSlideVideos);

}

function loadCarouselVideos(slideEl) {
    if (!slideEl) return;
    if (slideEl.classList.contains('is-clone')) return;
    if (!vimeoAllowed()) return;
    const iframes = slideEl.querySelectorAll('iframe[data-carousel-video]');
    if (iframes.length === 0) return;
    setTimeout(() => {
        iframes.forEach(iframe => {
            if (iframe.src) return;
            // ukryty wariant (np. .desktop-video na mobile) pobierałby strumień Vimeo w tle
            if (getComputedStyle(iframe).display === 'none') return;
            iframe.src = iframe.dataset.carouselVideo;
            delete iframe.dataset.carouselVideo;
        });
    }, 500);
}


const overflowCarousels = document.querySelectorAll('.overflow-carousel');
overflowCarousels.forEach(carousel => {
    function startCarousel() {
        const overflowCarousel = Carousel(carousel, {
            slidesPerPage: 'auto',
            tween: {
                tension: 160,
                friction: 30,
            },
            infinite: false,
            fill: true,
            center: false,
            dragFree: true,
            Lazyload: {
                preload: 0
            },
            enabled: true,
            breakpoints: {
                "(max-width: 1279px)": {
                    enabled: false,
                },
            },
            on: {
                change: () => {
                    carousel.classList.remove('start-reached');
                    carousel.classList.remove('end-reached');
                },

                settle: () => {
                    let currentPage = overflowCarousel.getPageIndex();
                    let carouselLength = overflowCarousel.getPages().length - 1;

                    if (currentPage == 0 && overflowCarousel.getPageProgress() === 0) {
                        carousel.classList.add('start-reached');
                    } else {
                        carousel.classList.remove('start-reached');
                    }

                    if (currentPage == carouselLength && overflowCarousel.getPageProgress() === 0) {
                        carousel.classList.add('end-reached');
                    } else {
                        carousel.classList.remove('end-reached');
                    }
                }
            }
        }, {
            Lazyload
        }).init();
    }

    decideLoad(carousel, startCarousel);
});

const basicCarousels = document.querySelectorAll('.basic-carousel');
basicCarousels.forEach(carousel => {
    function startCarousel() {
        const basicCarousel = Carousel(carousel, {
            slidesPerPage: (basicCarousel) => {
                return (basicCarousel.getTotalSlideDim() > basicCarousel.getViewportDim()) ? 1 : 'auto';
            },
            infinite: false,
            transition: 'slide',
            fill: true,
            center: false,
            Lazyload: {
                preload: 0
            },
            on: {
                change: () => {
                    document.querySelectorAll('.equipment-tippy').forEach(el => {
                        el._tippy?.hide();
                    });
                }
            }
        }, {
            Lazyload
        }).init();
    }

    decideLoad(carousel, startCarousel);
});


const proofCarousels = document.querySelectorAll('.proof-banners-wrapper');
proofCarousels.forEach(carousel => {
    function startCarousel() {
        let rotationTime = getRotationTime(carousel);

        const rwdCarousel = Carousel(carousel, {
            slidesPerPage: (rwdCarousel) => {
                return (rwdCarousel.getTotalSlideDim() > rwdCarousel.getViewportDim()) ? 1 : 'auto';
            },
            infinite: true,
            Autoplay: rotationTime ? { showProgressbar: false, timeout: rotationTime, } : false,
            fill: true,
            center: false,
            Lazyload: {
                preload: 5
            },

            enabled: true,
            breakpoints: {
                "(min-width: 701px)": {
                    enabled: false,
                },
            }

        }, {
            Lazyload,
            Autoplay
        }).init();
    }

    decideLoad(carousel, startCarousel);
});

function getRotationTime(carousel) {
    const rotationTime = parseInt(carousel.dataset.rotationTime);
    if (isNaN(rotationTime)) return false;
    return rotationTime;
}

function decideLoad(carousel, startFunction) {
    let carouselStarted = false;

    let isLazy = carousel.classList.contains('lazy-init');
    if (isLazy) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !carouselStarted) {
                    startFunction();
                    carouselStarted = true;

                }
            });
        });
        observer.observe(carousel);

    } else {
        startFunction();
        carouselStarted = true;
    }
}

window.BuildDetailGallery = function () {

    const detailCarousel = document.getElementById("detail-carousel");
    if (!detailCarousel) return;

    window.DetailMainCarousel = Carousel(detailCarousel, {

        infinite: false,
        Thumbs: false,
        breakpoints: {
            "(min-width: 1279px)": {

                Thumbs: {
                    type: "classic",
                    Carousel: {

                        vertical: false,
                        center: true,
                    },
                }
            }
        },
        Lazyload: {
            preload: 0
        }
    }, {
        Lazyload,
        Arrows,
        Thumbs
    }).init();

}

const typeOf = document.body.getAttribute('data-type');
if (["detail", "cms", "cart"].includes(typeOf)) {
    let fancyboxReady = null;


    const initFancybox = () => {
        if (!fancyboxReady) {

            fancyboxReady = import('@fancyapps/ui').then(({ Fancybox }) => {
                document.removeEventListener('click', earlyFancyboxClick, true);

                Fancybox.bind("[data-fancybox]", {
                    placeFocusBack: false,
                    hideScrollbar: false,
                    Hash: false,
                });

                Fancybox.bind('[data-run-fancybox=""]', {
                    autoFocus: false,
                    trapFocus: false,
                    placeFocusBack: false,
                    groupAll: true,
                    hideScrollbar: false
                });

                document.body.addEventListener("click", function (e) {
                    const link = e.target.closest("a.rates-button");
                    if (!link) return;

                    e.preventDefault();

                    Fancybox.show([
                        {
                            src: link.href,
                            type: "iframe",
                            width: "min(1440px, calc(100dvw - 40px))",
                            height: "min(1000px, calc(100dvh - 160px))"
                        }
                    ], {
                        dragToClose: false
                    });
                });

            });
        }
        return fancyboxReady;
    };

    const earlyFancyboxClick = (event) => {
        const target = event.target.closest('[data-fancybox], [data-run-fancybox=""], a.rates-button');

        if (!target) return;

        event.preventDefault();
        event.stopPropagation();

        initFancybox().then(() => target.click());
    };

    document.addEventListener('click', earlyFancyboxClick, true);

    if (document.readyState === 'complete') {
        setTimeout(initFancybox, 0);
    } else {
        window.addEventListener('load', () => setTimeout(initFancybox, 0), { once: true });
    }
}